import React, { useMemo } from 'react'
import {
  PublicationQueryPreferencesFragment,
  useGetPublicationListingQuery,
} from '@sketch/gql-types'

// Components
import { GenericError } from '@sketch/components'

// Local Components
import CommunityWrapper from '../../components/CommunityWrapper'
import CommunityPublicationGrid from '../../components/CommunityPublicationGrid'
import { PublicationGridPlaceholder } from '../../components/PublicationGrid'
import CommunityListingHeader, {
  CommunityListingHeaderPlaceholder,
} from '../../components/CommunityListingHeader'

interface CommunityListingPageProps {
  listIdentifier: string
}

const PreventiveCommunityGrid = (props: {
  preferences: PublicationQueryPreferencesFragment
}) => {
  /**
   * When rendering the Listing page the props "allowPagination" and "limit"
   * need to be corrected given that we should show all items in these listings.
   * - Limit should be not set
   * - Allow pagination should be "true"
   */
  const preferences = useMemo(() => {
    const { allowPagination, limit, ...preferences } = props.preferences
    return { ...preferences, allowPagination: true }
  }, [props.preferences])

  return <CommunityPublicationGrid preferences={preferences} />
}

const CommunityListingPage = (props: CommunityListingPageProps) => {
  const { listIdentifier } = props

  const { data, loading, error } = useGetPublicationListingQuery({
    variables: { identifier: listIdentifier },
  })

  if (loading) {
    return (
      <CommunityWrapper>
        <CommunityListingHeaderPlaceholder />
        <PublicationGridPlaceholder />
      </CommunityWrapper>
    )
  }

  if (error || !data) {
    return <GenericError />
  }

  const { publicationListing } = data

  return (
    <CommunityWrapper>
      <CommunityListingHeader title={publicationListing.title} />
      <PreventiveCommunityGrid preferences={publicationListing.preferences} />
    </CommunityWrapper>
  )
}

export default CommunityListingPage
